import { useMemo } from 'react';

import { EPollState, IPoll, TPollsList } from '../../../../types/interaction_tools';

export function usePolls(polls: TPollsList) {
  const activePolls: Array<IPoll> = useMemo(
    () => Object.values(polls).filter((poll) => poll.state !== EPollState.ARCHIVED),
    [polls],
  );

  const archivedPolls: Array<IPoll> = useMemo(
    () => Object.values(polls).filter((poll) => poll.state === EPollState.ARCHIVED),
    [polls],
  );

  return {
    activePolls,
    archivedPolls,
  };
}
